export default __webpack_public_path__ + "static/media/youtube_outlined.74106483.svg";